import type {Prompt} from '@cp/model';
import {useCallback, useState} from 'react';
import {promptsGenerateStudy} from '../../api/callable/prompts';

export interface GenerateStudyPromptsVariables {
  moduleId: string;
  topic: string;
  additionalInfo?: string;
}

export function useGenerateStudyPrompts() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  const generateStudyPrompts = useCallback(async (variables: GenerateStudyPromptsVariables): Promise<Prompt> => {
    setLoading(true);
    setError(undefined);
    try {
      return await promptsGenerateStudy(variables);
    } catch (err) {
      const e = err instanceof Error ? err : new Error(String(err));
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    generateStudyPrompts,
    loading,
    error,
  };
}
